export const USER_SHOW                     = '@@USER_SHOW'
export const USER_UPDATE                   = '@@USER_UPDATE'
export const USER_SIGN_UP                  = '@@USER_SIGN_UP'
export const USER_SIGN_IN                  = '@@USER_SIGN_IN'
export const USER_DESTROY                  = '@@USER_DESTROY'

export const ADD_TO_FAVORITES              = '@@ADD_TO_FAVORITES'
export const FAVORITES_DESTROY             = '@@FAVORITES_DESTROY'
export const FAVORITES_INDEX               = '@@FAVORITES_INDEX'

export const ORDERS_INDEX                  = '@@ORDERS_INDEX'



// WEBPACK FOOTER //
// ./src/features/Personal/actionTypes.js